// extracted by mini-css-extract-plugin
module.exports = {"container":"Pivot-module--container--34yqX","overlay":"Pivot-module--overlay--1iAcP"};